import { useMediaQuery, useDebouncedValue } from "@mantine/hooks";
import { Button, CloseButton, Input, Loader, Modal, rem, Tabs, TextInput } from "@mantine/core";
import React, { useEffect, useMemo, useState } from "react";
import Navigation from "../sidebar/Navigation";
import "./PlaceOrdersDetails.css";
import { createB2BAPI } from "../../../api/Interceptor";
import { BASE_URL } from "../../../api/EndPoints";
import { useLocation, useNavigate } from "react-router-dom";
import _, { filter } from "lodash";
import { faBan, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment/moment";
import PaymentDetailPage from "./PaymentDetailPage";
import notify from "../../../utils/Notification";
import { COMPANY_NAME, KEY_PAYMENT } from "../../../api/PaymentKey";
import PayNow from "../../../PayNow";
import { FaBell, FaInfoCircle, FaRegBell, FaSolarPanel } from "react-icons/fa";
import SortDropdown from "../../../SortDropdown";
import { DateInput } from "@mantine/dates";
import { IconX } from "@tabler/icons-react";

const initialTransaction = {
  bankName: "",
  utrNo: "",
  depositAmount: "",
  dateOfDeposit: null,
  customerOrderNo: "",
};
const PlaceOrdersDetails = ({ orderType }) => {
  console.log(orderType, "ordertype dd")
  const isMobile = useMediaQuery("(max-width: 767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 991px)");
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();
  const [saveTransaction, setSaveTransaction] = useState(false);
  const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]); const [showToast, setShowToast] = useState(false);
  const [relord, setReload] = useState(true)
  const [cancelOpened, setCancelOpened] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({});
  const [isCancelling, setIsCancelling] = useState(null);
  const location = useLocation();
  const [search, setSearch] = useState("")
  const [debouncedSearch] = useDebouncedValue(search, 500);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState(new Date().toISOString().split("T")[0]);
  const variantOptions = useMemo(() => {
    const options = [
      "NEW", "DC ORDER", "PACKED",
      "INVOICED", "SHIPPED", "DELIVERED",
      "CANCELLED"
    ];
    if (orderType === "WHOLESALE") {
      options.splice(1, 0, "PART PROCESSED");
      options.push("RETURNED", "NON RETURNABLE");
    }
    return options;
  }, [orderType]);
  const getTabDisplayName = (tab) => {
    const map = {
      "NEW": "NEW SO",
      "PART PROCESSED": "ALLOCATION ",
      "DC ORDER": "DC",
    };
    return map[tab] || tab;
  };

  const [activeTab, setActiveTab] = useState(
    location?.state?.activeTabFromLocation ? location?.state?.activeTabFromLocation : variantOptions[0]
  );
  console.log(activeTab, "active tabs")
  console.log(activeTab, "tabg")
  const [isTransactionUploaded, setIsTransactionUploaded] = useState({});
  const [activeCancelOrder, setActiveCancelOrder] = useState(null);
  const [groupList, setGrouplist] = useState({});
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [paymentOpened, setPaymentOpened] = useState(false);
  const [updatingOrderId, setUpdatingOrderId] = useState(null);
  const [allOrdersByStatus, setAllOrdersByStatus] = useState({});
  const [rawOrderCount, setRawOrderCount] = useState(0);
  const [complatedNonReturn, setCompletedNonReturn] = useState([]);
  const [nrgCompletedRowCount, setNrgCompletedRowCount] = useState(0);
  const [nonReturn, setNonReturn] = useState([]);
  const [nrgRowCount, setNrgRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [uom, setUom] = useState({})
  const [metre, setMetre] = useState({})
  const [allRibOrders, setAllRibOrders] = useState([])
  const [salesOrder, setSalesOrder] = useState({
    paymentHistory: {},
  });
  console.log(salesOrder, "sloksos")
  useEffect(() => {
    if (location?.state?.activeTabFromLocation) {
      setActiveTab(location?.state?.activeTabFromLocation);
    }
  }, [location]);
  const prevOrderTypeRef = React.useRef(orderType);
  useEffect(() => {
    fetchAllOrdersForCounts();
  }, [activeTab, debouncedSearch, fromDate, toDate, orderType, relord]);

  useEffect(() => {
    setPage(0)
    setGrouplist({})
    setOrders([]);
    fetchAllOrders();
  }, [activeTab, debouncedSearch, fromDate, toDate, orderType, relord]);

  useEffect(() => {
    const orderTypeChanged = orderType !== prevOrderTypeRef.current;
    if (orderTypeChanged) {
      setSearch("");
      setFromDate("");
      setPage(0);
      setGrouplist({});
      setOrders([]);
      setHasMore(true);
      prevOrderTypeRef.current = orderType;
    }
    fetchAllOrdersForCounts();
    fetchAllOrders();
  }, [
    orderType,
    activeTab,
    page,
    relord,
  ]);

  const counts = useMemo(() => {
    return variantOptions.reduce((acc, status) => {
      acc[status] = allOrdersByStatus[status] || 0;
      return acc;
    }, {});
  }, [allOrdersByStatus, orderType]);

  const handleClear = () => {
    setSearch("");
    setFromDate("");
  }

  const fetchAllOrdersForCounts = async () => {
    if ((page !== 0 && !hasMore) || loading) return;
    const statuses = [
      "NEW",
      "PART PROCESSED",
      "PACKED",
      "INVOICED",
      "SHIPPED",
      "DELIVERED",
      "CANCELLED",
      "RETURNED",
      "NON RETURNABLE",
    ];
    const allOrders = {};

    for (const status of statuses) {
      try {
        let res;
        let count = 0;

        if (status === "NEW" || status === "PART PROCESSED") {
          const body = {
            fetchCancelled: false,
            fetchDelivered: false,
            fetchInvoice: false,
            fetchNewOrder: true,
            fetchPacked: false,
            fetchShipped: false,
            fromDate: fromDate || null,
            search: debouncedSearch || "",
            status: status === "PART PROCESSED" ? "PART_CONFIRMED" : status,
            orderType,
            toDate: toDate || null,
          };

          res = await B2B_API.post(
            `order/search?page=0&pageSize=1&orderType=${orderType}`,
            { json: body }
          );
        } else if (status === "RETURNED") {
          res = await B2B_API.get(
            `return/all/customer?orderStatus=${status}&page=0&pageSize=1&orderType=${orderType}&search=${debouncedSearch}&fromDate=${fromDate}&toDate=${toDate}`
          );
        } else if (status === "CANCELLED") {
          res = await B2B_API.get(
            `order/allByStatus?orderStatus=${status}&page=${page}&pageSize=1&orderType=${orderType}&search=${debouncedSearch}&fromDate=${fromDate}&toDate=${toDate}`
          );
        } else if (status === "NON RETURNABLE") {
          res = await B2B_API.get(
            `return/nrg/nonAcceptableReturns?delivered=true&page=${page}&size=1&search=${debouncedSearch}&fromDate=${fromDate}&toDate=${toDate}`
          );
        }

        else {
          res = await B2B_API.get(
            `receipt/allByStatus?orderStatus=${status}&page=0&pageSize=1&orderType=${orderType}&search=${debouncedSearch}&fromDate=${fromDate}&toDate=${toDate}`
          );
        }

        const data = await res.json();
        console.log(data, "dat fro j")
        count = data?.response?.totalElements || 0;

        allOrders[status] = count;
      } catch (error) {
        console.error(`Error fetching ${status} orders:`, error);
        allOrders[status] = [];
      }
      try {
        const dcRes = await B2B_API.get(
          `receipt/dc-orders?page=0&pageSize=1&orderType=${orderType}&search=${debouncedSearch}&fromDate=${fromDate}&toDate=${toDate}`
        );
        const dcData = await dcRes.json();

        allOrders["DC ORDER"] = dcData?.response?.totalElements || 0;
      } catch (e) {
        console.error("Error fetching DC ORDER:", e);
        allOrders["DC ORDER"] = 0;
      }
    }

    setAllOrdersByStatus(allOrders);
  };
  const renderColorCode = (items = []) => {
    const colors = items.flatMap(
      i => i?.productVariant?.variants?.filter(v => v?.hexaColorCode) || []
    );

    if (!colors.length) return null;

    return (
      <span className={`colorchips ${"borderable"}`} style={{ display: "flex", marginBottom: "0px", gap: "1px", alignItems: 'center' }}>
        <span style={{ marginRight: "2px" }}>Colors: </span>
        {colors.map((c, i) => (
          <span
            key={i}
            className="colorchip"
            style={{ display: "flex", alignItems: "center", backgroundColor: c.hexaColorCode, border: "1px solid #000000ff; ", borderColor: "gray" }}
          />
        ))}
      </span>
    );
  };

  const fetchAllOrders = async () => {
    if ((page !== 0 && !hasMore) || loading) return;
    setLoading(true);
    try {
      let res;
      if (activeTab === "NEW" || activeTab === "PART PROCESSED") {
        const body = {
          fetchCancelled: false,
          fetchDelivered: false,
          fetchInvoice: false,
          fetchNewOrder: true,
          fetchPacked: false,
          fetchShipped: false,
          fromDate: fromDate || null,
          search: debouncedSearch || "",
          status: activeTab === "PART PROCESSED" ? "PART_CONFIRMED" : activeTab,
          orderType,
          toDate: toDate || null,
        };
        res = await B2B_API.post(
          `order/search?page=${page}&pageSize=10&orderType=${orderType}`,
          { json: body }
        );
      } else if (activeTab === "RETURNED") {
        res = await B2B_API.get(
          `return/all/customer?orderStatus=${activeTab}&page=${page}&pageSize=10&orderType=${orderType}&search=${debouncedSearch}&fromDate=${fromDate}&toDate=${toDate}`
        );
      } else if (activeTab === "CANCELLED") {
        res = await B2B_API.get(
          `order/allByStatus?orderStatus=${activeTab}&page=${page}&pageSize=10&orderType=${orderType}&search=${debouncedSearch}&fromDate=${fromDate}&toDate=${toDate}`
        );
      } else if (activeTab === "NON RETURNABLE") {
        res = await B2B_API.get(
          `return/nrg/nonAcceptableReturns?delivered=true&page=${page}&size=${10}&search=${debouncedSearch}&fromDate=${fromDate}&toDate=${toDate}`
        );
      }
      else if (activeTab === "DC ORDER") {
        res = await B2B_API.get(
          `receipt/dc-orders?page=${page}&pageSize=10&orderType=${orderType}&search=${debouncedSearch}&fromDate=${fromDate}&toDate=${toDate}`
        );
      }
      else {
        res = await B2B_API.get(
          `receipt/allByStatus?orderStatus=${activeTab}&page=${page}&pageSize=10&orderType=${orderType}&search=${debouncedSearch}&fromDate=${fromDate}&toDate=${toDate}`
        );
      }


      const data = await res.json();

      console.log(data, "dat fro data j")
      let filteredData = [];

      if (activeTab === "CANCELLED") {
        filteredData = (data?.response?.content || []).filter(
          o => o.orderType === orderType
        );
      } else if (activeTab === "RETURNED") {
        filteredData = data?.response?.content || [];
      } else if (activeTab === "NON RETURNABLE") {
        filteredData = data?.response?.content || [];
      }
      else {
        filteredData = data?.response?.content?.filter(
          o => o.orderType === orderType
        );
      }


      const sku = [...filteredData.map((item) => item.variantSku)];
      const uom = await B2B_API.get(
        `product/uomByProduct?sku=${sku}`
      ).json();
      const merePerRoll = {}
      const result = {};
      Object.entries(uom?.response).forEach(([id, val]) => {
        if (val.kg) {
          result[id] = "kgs";
        } else if (val.metre) {
          result[id] = "metre";
        } else if (val.yard) {
          result[id] = "yard";
        }
      });
      Object.entries(uom?.response).forEach(([id, val]) => {
        merePerRoll[id] = val?.metreValue;
      });
      setUom(result);
      setMetre(merePerRoll)


      const sorted = _.sortBy(filteredData, "createdDate").reverse();

      const groupKey = order => order.orderNo || order.receiptNo;
      const newGrouped = _.groupBy(sorted, groupKey);
      console.log(newGrouped, "nknknkn")
      setGrouplist(prev => {
        const merged = { ...prev };

        Object.entries(newGrouped).forEach(([key, value]) => {
          merged[key] = value;

          const ribItems = value.flatMap(order =>
            (order?.items || []).filter(item => !!item.fabricPimVariantId)
          );
          const ribItemsProcessed = value.flatMap(order =>
            (order?.orderReceipts || []).filter(
              receipt => receipt?.items || []
            ).flatMap(receipt => (receipt?.items || []).filter(item => !!item.fabricPimVariantId))
          )

          value.forEach(order => {
            order.items?.forEach(item => {
              if (!item.fabricPimVariantId) {
                const matchingRib = ribItems.find(
                  rib => rib.fabricPimVariantId === item.pimVarinatId
                );
                if (matchingRib) {
                  item.ribItem = matchingRib;
                }
              }
            });

            order.items = (order.items || []).filter(
              item => item.ribItem || !item.fabricPimVariantId
            );
          });

          value.forEach(order => {
            order.orderReceipts?.forEach(receipt => {
              receipt.items?.forEach(item => {
                if (!item.fabricPimVariantId) {
                  const matchingRib = ribItemsProcessed.find(
                    rib => rib.fabricPimVariantId === item.pimVarinatId
                  );
                  if (matchingRib) {
                    item.ribItem = matchingRib;
                  }
                }
              });
            });
            order.orderReceipts = (order.orderReceipts || []).filter(
              receipt =>
                (receipt.items || []).some(
                  item => item.ribItem || !item.fabricPimVariantId
                )
            )
          })
        });

        return merged;
      });


      setHasMore(page < data?.response?.totalPages);
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoading(false);
    }
  };


  const getDeliveryStatusMessage = (status) => {
    switch (status) {
      case "NEW":
        return "Your Order has been placed Successfully";
      case "PART_CONFIRMED":
        return "Your Order is In-Progress";
      case "CONFIRMED":
        return "Your Order is In-Progress";
      case "PACKED":
        return "Your Order has been packed";
      case "INVOICED":
        return "Your Order has been invoiced";
      case "SHIPPED":
        return "Your Order has been shipped";
      case "DELIVERED":
        return "Your Order has been delivered";
      case "CANCELLED":
        return "Your Order has been cancelled";
      case "RETURNED":
        return "Your Order has been Returned";
      case "NON RETURNABLE":
        return "Your Order has been -";
      default:
        return "Status not available";
    }
  };

  const handleRowClick = (order) => {
    console.log("ckicl order", order)

    const stateData = {
      activeTab,
      AllItemWithRib: order,
      ...(activeTab === 'NON RETURNABLE' ? { nrgp: order } : {})
    };

    if (!order?.receiptNo) {
      navigate(`/order-Details?orderNo=${order?.orderNo}`, { state: stateData, AllItemWithRib: order?.items });
    } else {
      navigate(`/order-Details?receiptNo=${order?.receiptNo}`, { state: stateData, AllItemWithRib: order?.items });
    }
  };

  const handleRowClickNrgp = (order) => {
    if (!order?.receiptNo) {
      navigate(`/order-Details?orderNo=${order?.orderNo}`, {
        state: activeTab,
      });
    } else {
      navigate(`/order-Details?receiptNo=${order?.receiptNo}`, {
        state: activeTab,
      });
    }
  };

  const handleTabChange = (option) => {
    setActiveTab(option);
  };

  const handleClickOutside = (event) => {
    if (event.target.classList.contains("modal-backdrop")) {
      setActiveCancelOrder(null);
    }
  };

  useEffect(() => {
    if (activeCancelOrder) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [activeCancelOrder]);


  const paymentOpen = (order) => {
    setSalesOrder({
      ...order,
      payment: {
        ...order.payment,
        depositAmount: order?.payment?.amountNeedToBePaid || 0,
      },
      customerId: order.customer?.customerId || order.customerId,
    });

    setPaymentOpened(true);
  };

  const paymentClose = () => {
    setPaymentOpened(false);
    setSalesOrder({ payment: {} });
    setPage(0);
    setHasMore(true);
    setGrouplist({});
    setOrders([]);
    setAllOrdersByStatus({});
    setReload(prev => !prev);
  };

  const acceptPayment = async (order) => {
    try {
      const res = await B2B_API.get("customer/profile").json();
      const { companyName, mobileNo, email } = res?.response
      const { receiptNo, orderNo } = salesOrder;

      const url = receiptNo
        ? `onlinePayment/create_for_dc?orderId=${receiptNo}`
        : `onlinePayment/create_for_order?orderId=${orderNo}`;
      const createOrderRes = await B2B_API.post(url).json();
      const orderData = createOrderRes;

      if (!orderData || !orderData.orderId) {
        throw new Error('Failed to create Razorpay order');
      }

      const loadScript = (src) =>
        new Promise((resolve) => {
          const script = document.createElement("script");
          script.src = src;
          script.onload = () => resolve(true);
          script.onerror = () => resolve(false);
          document.body.appendChild(script);
        });

      const isRazorpayLoaded = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

      if (!isRazorpayLoaded) {
        alert("Failed to load Razorpay SDK. Please check your internet.");
        return;
      }

      // Step 3: Open Razorpay modal
      const options = {
        key: KEY_PAYMENT,
        amount: orderData.amount * 100,
        currency: orderData.currency,
        name: COMPANY_NAME,
        description: orderData.description,
        order_id: orderData.orderId,
        handler: async function (response) {
          const { razorpay_order_id, razorpay_payment_id, razorpay_signature } = response;

          // Step 1: Verify payment on backend
          const verifyRes = await B2B_API.post(`onlinePayment/verify?razorpayOrderId=${razorpay_order_id}&razorpayPaymentId=${razorpay_payment_id}&razorpaySignature=${razorpay_signature}`, { json: null }).json();

          const verified = verifyRes;
          if (!verified) {
            alert("❌ Payment verification failed");
            return;
          }

          // Step 4: Call backend to update payment
          const url = receiptNo
            ? `receipt/update-payment?receiptNo=${receiptNo}`
            : `order/update-payment?orderNo=${orderNo}`;

          // await B2B_API.post(url, {
          //   ...salesOrder?.paymentHistory,
          //   depositAmount: salesOrder?.payment?.amountNeedToBePaid || 0,
          // });

          notify({
            error: false,
            success: true,
            title: "Payment received, waiting for approval",
          });
          fetchAllOrders();
          fetchAllOrdersForCounts();
          paymentClose();
          setShowToast(true);
          setTimeout(() => setShowToast(false), 3000);
        },
        prefill: {
          name: companyName,
          email: email,
          contact: mobileNo,
        },
        theme: {
          color: "#3399cc",
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();

    } catch (error) {
      console.error("Payment failed", error);
      notify({
        error: true,
        title: error.message,
      });
    }
  };
  const handleSaveRequest = async (id) => {
    try {
      console.log(id, "handke sid")
      const res = await B2B_API.post(`payment/raiseAfterRequest?id=${id}`);
    } catch (error) {
    }
  };

  const AcceptPaymentt = async (id) => {
    try {
      if (salesOrder?.paymentHistory?.accountNo !== salesOrder?.paymentHistory?.confirmAccountNo) {
        notify({
          error: true,
          success: false,
          title: 'Confirm account no mismatch'
        });
        return;
      }

      const { receiptNo, orderNo } = salesOrder;

      const url = receiptNo
        ? `receipt/update-payment?receiptNo=${receiptNo}`
        : `order/update-payment?orderNo=${orderNo}`;
      const res = await B2B_API.post(url, {
        json: {
          ...salesOrder?.paymentHistory,
          depositAmount: salesOrder?.payment?.amountNeedToBePaid || 0,
        },
      });
      await handleSaveRequest(id);
      notify({
        error: false,
        success: true,
        title: 'Payment received waiting for approval'
      })
      fetchAllOrders();
      fetchAllOrdersForCounts();
      paymentClose();
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);

    } catch (error) {
      notify({
        error: true,
        success: false,
        title: error?.message || 'Something went wrong'
      })
    }
  };
  const approveAdvance = async (payment) => {
    console.log(payment, "payment in approve advance")
    try {
      const payload = { ...payment };

      const res = await B2B_API
        .post("payment/requestAdjust", { json: payload })
        .json();

      notify({
        title: "Success!",
        message: res.message || "Payment proceed successfully",
        success: true,
      });

      const updatedPayment = res?.response;

      setSalesOrder(prev => ({
        ...prev,
        payment: updatedPayment,
      }));
      setPage(0);
      setHasMore(true);
      setGrouplist({});
      setOrders([]);
      setAllOrdersByStatus({});
      setReload(prev => !prev);
    } catch (error) {
      notify({
        error: true,
        title: error?.message || "Payment proceed failed",
      });
    }
  };

  const cancelProduct = async (order) => {
    setIsCancelling(order.orderNo);
    try {
      const url = `order/confirm-order`;
      const body = { ...order, orderStatus: 'CANCELLED' };
      await B2B_API.post(url, { json: body });
      notify({
        error: false,
        success: true,
        title: "Order Cancelled Successfully",
      });
      setGrouplist({})
      fetchAllOrders();
      fetchAllOrdersForCounts();
    } catch (error) {
      console.error("Cancel error:", error);
      notify({
        error: true,
        success: false,
        title: error?.message || "Something went wrong while cancelling order",
      });
    } finally {
      setIsCancelling(null);
    }
  };

  const ShipmentUpdat = async (clickedOrder, newStatus = "DELIVERED", id) => {
    setUpdatingOrderId(id);
    try {
      let payload = {};

      if (clickedOrder.receiptNo) {
        payload = {
          receiptNo: clickedOrder.receiptNo,
          orderStatus: newStatus,
        };
      }
      const res = await B2B_API.post(`receipt/deliver`, {
        json: payload,
      });
      notify({
        error: false,
        success: true,
        title: res?.message || 'Your Order has been Delivered'
      })
      setGrouplist({})
      fetchAllOrders();
      fetchAllOrdersForCounts();
      setUpdatingOrderId(null);
    } catch (error) {
      notify({
        error: true,
        success: false,
        title: error?.message || 'Error updating shipment status'
      })
    }
  };



  const handleConfirmCancel = async (receiptNo) => {
    try {
      const url = receiptNo?.receiptNo
        ? `receipt/confirm-order`
        : `order/confirm-order`;
      let body = {};
      if (receiptNo?.receiptNo) {
        body = {
          receiptNo: receiptNo?.receiptNo,
          orderStatus: "CANCELLED",
        };
      } else {
        body = {
          orderNo: receiptNo?.orderNo,
          orderStatus: "CANCELLED",
        };
      }
      await B2B_API.post(url, { json: body });
      setActiveCancelOrder(null);
      fetchAllOrders();
      setPage(0);
      setHasMore(true);
    } catch (error) {
      console.error("Error canceling order:", error);
    }
  };

  const handleCloseCancelPopup = () => {
    setActiveCancelOrder(null);
  };

  return (
    <>
      <div className="view-my-page router-view-container">
        <div className="route-view">
          {!isMobile && !isTablet && <Navigation />}



          <Tabs
            value={activeTab}
            onChange={(e) => {
              setActiveTab(e);
              setHasMore(true);
              setGrouplist({});
              setPage(0);
              setSearch("");
              setFromDate("");
              setReload(prev => !prev)
            }}
          >
            <Tabs.List
              styles={{

                list: {
                  flexWrap: "nowrap",
                  overflowX: 'auto',
                  whiteSpace: 'nowrap',
                  scrollbarWidth: 'none',

                },
              }}
            >
              {variantOptions?.map((item) => (
                <Tabs.Tab
                  key={item}
                  value={item}
                  onClick={() => handleTabChange(item)}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span>{getTabDisplayName(item)}</span>
                    <span
                      className="tab-count"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: "18px",
                        height: "18px",
                        borderRadius: "9px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        padding: "0 4px",
                        marginLeft: "6px",
                        verticalAlign: "middle",
                        backgroundColor: item === activeTab ? "white" : "#8BC53F",
                        color: item === activeTab ? "#8BC53F" : "white",
                        boxShadow:
                          item === activeTab ? "0 0 0 1px #8BC53F" : "none",
                      }}
                    >
                      {counts[item] || 0}
                    </span>
                  </div>
                </Tabs.Tab>
              ))}
            </Tabs.List>
            <div
              style={{
                display: "flex",
                flexDirection: window.innerWidth <= 768 ? "column" : "row",
                gap: "10px",
                marginTop: "1rem",
                alignItems: window.innerWidth <= 768 ? "stretch" : "center",
              }}
            >
              <Input
                type="text"
                placeholder="Search Order"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              {window.innerWidth > 768 && (
                <>
                  <Input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />

                  <Input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    max={new Date().toISOString().split("T")[0]}
                  />
                  <Button
                    color="red"
                    variant="light"
                      disabled={!search && !fromDate}
                    onClick={handleClear}
                    leftSection={<IconX size={16} />}
                  >
                    Clear
                  </Button>
                </>
              )}

              {window.innerWidth <= 768 && (
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    width: "100%",
                  }}
                >
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    style={{ flex: 1, fontSize: "12px" }}
                  />

                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    max={new Date().toISOString().split("T")[0]}
                    style={{ flex: 1, fontSize: "12px" }}
                  />

                  <Button
                    color="red"
                    variant="light"
                    disabled={!search && !fromDate}
                    onClick={handleClear}
                  >
                    Clear
                  </Button>
                </div>
              )}
            </div>
            <Tabs.Panel value={activeTab}>
              <InfiniteScroll
                next={() => {
                  setPage((prev) => prev + 1);
                }}
                hasMore={hasMore}
                loader={
                  loading && (
                    <div className="loading-container">
                      <Loader color={"var(--primary)"} type="oval" />
                    </div>
                  )
                }
                dataLength={Object.keys(groupList).length}
                scrollThreshold={0.6}
              >
                {Object.keys(groupList).length > 0 ? (
                  <div
                    className="order-container"
                    style={{ marginTop: "2rem" }}
                  >
                    {Object.entries(groupList).map(([orderNo, orders]) => (
                      console.log(orders, "ordssssers"),
                      <div key={orderNo} className="order-group">
                        {orders.map((order, idx) => {
                          console.log(order, "orderdd")
                          const id = order.id ?? order.receiptId ?? order.orderId;

                          const base = id
                            ? `id-${id}`
                            : order.receiptNo
                              ? `receipt-${order.receiptNo}`
                              : order.orderNo
                                ? `order-${order.orderNo}`
                                : `fallback-${orderNo}-${idx}`;

                          const uniqueKey = `${base}-group-${orderNo}-idx-${idx}`;
                          console.log(order, "mk")
                          return (
                            <React.Fragment key={uniqueKey}>
                              <div className="order-details" style={{ marginBottom: "2rem" }}>
                                {isMobile && (<div style={{ display: "flex", flexDirection: 'row' }}>
                                  <span style={{ display: "flex", fontSize: "14px", fontWeight: "bold", color: "#8BC54F" }}>
                                    Total Amt : ₹ {activeTab === "NON RETURNABLE" ? order?.grossNonSaleableAmount :
                                      Math.round(order.grossTotal)}
                                  </span>
                                  <span style={{ display: "flex", alignItems: "center", marginLeft: "5px" }} className="total-amount" >{activeTab === "NON RETURNABLE" ? "(tax charges)" : "(shippment+packing+tax charges)"}</span>

                                </div>)}
                                {isMobile && order?.purchaseMode === 'SO' && (<div style={{ display: 'flex', flexDirection: "row", fontSize: "12px" }} >
                                  <span style={{ display: "flex", paddingLeft: "2px", color: "#ff0000ff" }}> Refund Not Allowed For This Order</span><span style={{ display: "flex", paddingLeft: "3px", alignItems: "center", fontWeight: "lighter", color: "#ff0000ff" }}><FontAwesomeIcon icon={faBan} /> </span>

                                </div>)}
                                {isMobile && activeTab !== "PART PROCESSED" && activeTab !== "DC ORDER" && order?.orderStatus !== "CANCELLED" && (
                                  <div style={{ 
                                    display: "flex", 
                                    flexDirection: "row", 
                                    marginBottom: "14px", 
                                    justifyContent: "space-between", 
                                    alignItems: "center",
                                    backgroundColor: "#ffffff",
                                    borderRadius: "10px",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.06)",
                                    border: "1px solid #edf2f7",
                                    padding: "12px 10px"
                                  }}>
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
                                      <h6 style={{ color: "#718096", fontSize: "11px", margin: 0, fontWeight: "600", textTransform: "uppercase" }}>Order Amt</h6>
                                      <h6 style={{ color: "#D68A00", fontSize: "13px", margin: "4px 0 0 0", fontWeight: "bold" }}>₹ {Math.round((order?.payment?.totalAmount || 0) - (order?.payment?.paidAmount || 0))}</h6>
                                    </div>

                                    <div style={{ width: "1px", height: "28px", backgroundColor: "#e2e8f0" }}></div>

                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
                                      <h6 style={{ color: "#718096", fontSize: "11px", margin: 0, fontWeight: "600", textTransform: "uppercase" }}>Paid Amt</h6>
                                      <h6 style={{ color: "#0FA958", fontSize: "13px", margin: "4px 0 0 0", fontWeight: "bold" }}>₹ {Math.round(order?.payment?.paidAmount || 0)}</h6>
                                    </div>

                                    {order?.payment?.actualOrderStockpercentage !== null &&
                                      order?.payment?.actualOrderStockpercentage !== undefined &&
                                      order?.orderType === "WHOLESALE" && (
                                        <>
                                          <div style={{ width: "1px", height: "28px", backgroundColor: "#e2e8f0" }}></div>
                                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
                                            <h6 style={{ color: "#718096", fontSize: "11px", margin: 0, fontWeight: "600", textTransform: "uppercase" }}>Advance</h6>
                                            <h6 style={{ color: "#8a0fa9ff", fontSize: "13px", margin: "4px 0 0 0", fontWeight: "bold" }}>{order?.payment?.actualOrderStockpercentage} %</h6>
                                          </div>
                                        </>
                                    )}

                                   <div style={{ width: "1px", height: "28px", backgroundColor: "#e2e8f0" }}></div>

                                   <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
                                      <h6 style={{ color: "#718096", fontSize: "11px", margin: 0, fontWeight: "600", textTransform: "uppercase" }}>Pending</h6>
                                      <h6 style={{ color: "#0066CC", fontSize: "13px", margin: "4px 0 0 0", fontWeight: "bold" }}>₹ {Math.round(order?.payment?.amountNeedToBePaid || 0)}</h6>
                                    </div>
                                  </div>
                                )}

                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} >

                                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                                    <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
                                      <b>{order?.orderNo}</b>

                                      {order?.receiptNo && (
                                        <b> , {order.receiptNo}</b>
                                      )}

                                      {order?.returnNo && (
                                        <b> , {order.returnNo}</b>
                                      )}
                                    </span>
                                    <span style={{ fontSize: '12px', color: '#4a90e2', fontWeight: 'bold', fontStyle: 'oblique 90deg', fontFamily: "'Raleway', sans-serif", fontSize: '14px', }}>On {order?.createdDate ? moment(order.createdDate).format("MMM Do YYYY") : ''}</span>
                                  </div>
                                  {!isMobile && (<div style={{ display: "flex", flexDirection: 'column' }}>
                                    <span style={{ display: "flex", fontSize: "14px", fontWeight: "bold", color: "#8BC54F" }}>
                                      Total Amt : ₹ {activeTab === "NON RETURNABLE" ? order?.grossNonSaleableAmount :
                                        Math.round(order.grossTotal)}
                                    </span>
                                    <span style={{ display: "flex" }} className="total-amount" >{activeTab === "NON RETURNABLE" ? "(tax charges)" : "(shippment+packing+tax charges)"}</span>
                                  </div>)}

                                  {(order.orderStatus === "PACKED" ||
                                    order.orderStatus === "NEW" ||
                                    order.orderStatus === "PART_CONFIRMED" ||
                                    order.orderStatus === "CONFIRMED" ||
                                    order.orderStatus === "SHIPPED" ||
                                    order.orderStatus === "RETURNED" ||
                                    order.orderStatus === "INVOICED" ||
                                    order.orderStatus === "NON RETURNABLE" ||
                                    order.orderStatus === "DELIVERED") && activeTab !== "PART PROCESSED" && activeTab !== "DC ORDER" && (
                                      <div style={{ display: "flex", flexDirection: isMobile ? "column" : "column" }}>
                                        <div style={{ display: "flex", flexDirection: isMobile ? "row" : "row", gap: "10px", justifyContent: "flex-end" }}>


                                          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                                            <div style={{ display: "flex", flexDirection: "row", gap: "10px", justifyContent: "flex-end" }}>
                                              <div>
                                                {activeTab === "NEW" && order?.orderType !== "SWATCH" &&
                                                  (!order?.payment?.paidReferenceId ||
                                                    order?.payment?.paidReferenceId === "" ||
                                                    order?.payment?.paidReferenceId === null) && (
                                                    <Button
                                                      color="red"
                                                      onClick={() => {
                                                        setSelectedOrder(order);
                                                        setCancelOpened(true);
                                                      }}
                                                    >
                                                      {isCancelling === order.orderNo ? (
                                                        <>
                                                          <Loader size="sm" color="#8BC53F" style={{ marginRight: 8 }} /> Cancelling...
                                                        </>
                                                      ) : (
                                                        "Cancel"
                                                      )}
                                                    </Button>
                                                  )}

                                              </div>
                                              <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                                                {order?.payment?.amountNeedToBePaid > 0 ? (
                                                  <Button
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      paymentOpen(order);
                                                    }}
                                                    style={{
                                                      backgroundColor:
                                                        order?.utrNo || order?.payment?.amountNeedToBePaid === 0
                                                          ? '#dfecccff'
                                                          : '#8BC53F',
                                                      color:
                                                        order?.utrNo || order?.payment?.amountNeedToBePaid === 0
                                                          ? '#999'
                                                          : 'white',
                                                      cursor:
                                                        order?.utrNo || order?.payment?.amountNeedToBePaid === 0
                                                          ? 'not-allowed'
                                                          : 'pointer',
                                                      opacity:
                                                        order?.utrNo || order?.payment?.amountNeedToBePaid === 0
                                                          ? 0.6
                                                          : 1
                                                    }}

                                                    disabled={
                                                      order?.utrNo ||
                                                      order?.payment?.amountNeedToBePaid === 0
                                                    }
                                                  >
                                                    {isTransactionUploaded[orderNo]
                                                      ? "Paid"
                                                      : "Pay Now"}
                                                  </Button>
                                                ) :
                                                  <div >
                                                    {(order?.adjustmentPending == false && order?.payment?.paymentStatus === 'PAID' || (order?.purchaseMode !== 'SO' && order?.payment?.paymentStatus === 'DUE')) && <div>
                                                      <Button
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          paymentOpen(order);
                                                        }}
                                                        disabled={
                                                          order?.utrNo ||
                                                          order?.payment?.amountNeedToBePaid === 0
                                                        }
                                                        style={{
                                                          backgroundColor:
                                                            order?.utrNo || order?.payment?.amountNeedToBePaid === 0
                                                              ? '#dfecccff'
                                                              : '#8BC53F',
                                                          color:
                                                            order?.utrNo || order?.payment?.amountNeedToBePaid === 0
                                                              ? '#999'
                                                              : 'white',
                                                          cursor:
                                                            order?.utrNo || order?.payment?.amountNeedToBePaid === 0
                                                              ? 'not-allowed'
                                                              : 'pointer',
                                                          opacity:
                                                            order?.utrNo || order?.payment?.amountNeedToBePaid === 0
                                                              ? 0.6
                                                              : 1
                                                        }}

                                                      >
                                                        {isTransactionUploaded[orderNo]
                                                          ? "Paid"
                                                          : "Pay Now"}
                                                      </Button>
                                                    </div>}
                                                  </div>
                                                }</div></div>
                                            {order?.payment?.isRaiseRequest && !order?.payment?.paymentApproved ? <div style={{ display: "flex", fontSize: "12px", fontWeight: "bold", color: "#c53f3fff" }}>Received Payment Request <span style={{ display: "flex", alignItems: "center", marginLeft: "5px", size: "12px" }}><FaRegBell /></span></div> : ""}
                                          </div>

                                          {order.orderStatus === "SHIPPED" && (
                                            <>
                                              {order.shipmentNote?.stage === "DELIVERED" && (
                                                <Button
                                                  onClick={() =>
                                                    ShipmentUpdat(order, "DELIVERED", order?.id)
                                                  }
                                                  disabled={updatingOrderId === order.id}
                                                  style={{ backgroundColor: '#8BC53F', color: 'white', marginLeft: "5px" }}
                                                >
                                                  {updatingOrderId === order.id ? <><Loader size="sm" color="#8BC53F" style={{ marginRight: 8 }} />Confirming... </> : "Confirm"}
                                                </Button>
                                              )}
                                            </>
                                          )}
                                        </div>
                                        <div>
                                          {order?.orderType === "SWATCH" || order?.orderType === "SAMPLE" || order?.orderType === "WHOLESALE" ? (<div style={{ display: 'flex', flexDirection: "column", justifyContent: "flex-end", fontWeight: "bold" }}>
                                            <div style={{ display: 'flex', flexDirection: "column" }}>
                                              <span style={{
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                fontSize: '12px',
                                                color: order?.paymentApproved ? "#008000" : "rgb(197, 63, 63)"
                                              }}>
                                                {order?.payment?.paymentApproved ? "Payment Approved" : order?.payment?.paidAmount > 0 ? "Waiting For Payment Approval" : ""}
                                              </span></div></div>) : ""}</div>
                                      </div>

                                    )}
                                </div>

                                {activeTab === "NON RETURNABLE" && (
                                  <div
                                    key={order.id}
                                    className="order-navigate"
                                    onClick={() => handleRowClick(order)}
                                  >
                                    <div className="row">
                                      <div className="col-6-12">
                                        <div className="row">
                                          <div className="col-8-12">
                                            <div className="product-info">

                                              <span className="row-product-name" >
                                                {order?.nonReturnableLists?.[0]?.productName}
                                              </span>
                                              <div className="product-details">
                                                <span className="detail" >
                                                  {order?.nonReturnableLists[0]?.orderType === "WHOLESALE" && (

                                                    <>
                                                      {/* <span className="detail-label">
                                                              Color:{" "}
                                                            </span>
                                                            <span className="detail-value">
                                                              {item.productName?.split("/")?.[1]?.trim()}

                                                            </span> */}
                                                      <span>{renderColorCode(order?.items)}</span>
                                                      <div className="iYY1OFF">
                                                        <span className="E303nnp">
                                                          <div
                                                            style={{
                                                              fontSize: "12px",
                                                            }}
                                                            className="mKEOO+e"
                                                          >
                                                            UOM: {order?.uom}
                                                          </div>
                                                        </span>
                                                      </div>
                                                      {order?.nonReturnableLists[0]?.orderType === 'WHOLESALE' && <div className="iYY1OFF">
                                                        <span className="E303nnp">
                                                          <div
                                                            style={{
                                                              fontSize: "12px",
                                                            }}
                                                            className="mKEOO+e"
                                                          >
                                                            No of Rolls :{" "}
                                                            {(() => {
                                                              const items = order?.nonReturnableLists || [];
                                                              const totalQty = items.reduce((total, item) => {
                                                                const rolls = item?.rolls || [];
                                                                const sumWeights = rolls.reduce(
                                                                  (sum, roll) => sum + (roll?.noOfRoll || 0),
                                                                  0
                                                                );
                                                                return total + sumWeights;
                                                              }, 0);


                                                              return `${totalQty}`;
                                                            })()}
                                                          </div>
                                                        </span>
                                                      </div>}

                                                      <div className="iYY1OtyF">
                                                        <div className="E303tnynp">
                                                          <div
                                                            style={{
                                                              fontSize: "12px",
                                                            }}
                                                            className="mKEytOO+e"
                                                          >
                                                            Total Qty :{" "}
                                                            {(() => {
                                                              const items = order?.nonReturnableLists || [];
                                                              const totalQty = items.reduce((total, item) => {
                                                                const rolls = item?.rolls || [];
                                                                const sumWeights = rolls.reduce(
                                                                  (sum, roll) => sum + (roll?.actualWeight || 0),
                                                                  0
                                                                );
                                                                return total + sumWeights;
                                                              }, 0);


                                                              return `${totalQty}`;
                                                            })()}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div style={{ display: "flex", padding: "5px", fontWeight: "bold" }}>
                                        {!isMobile && activeTab !== "PART PROCESSED" && activeTab !== "DC ORDER" && order?.orderStatus !== "CANCELLED" && (<div style={{ display: "flex", flexDirection: "column" }}>
                                          <span style={{ display: "flex", justifyContent: "flex-start", fontSize: "12px", margin: 0, padding: 0 }}>Order Amt  : ₹ {Math.round((order?.payment?.totalAmount || 0) - (order?.payment?.paidAmount || 0))}</span>
                                          <span style={{ display: "flex", justifyContent: "flex-start", fontSize: "12px", margin: 0, padding: 0 }}>Paid Amt : ₹ {Math.round(order?.payment?.paidAmount || 0)}</span>
                                          {order?.payment?.actualOrderStockpercentage !== null &&
                                            order?.payment?.actualOrderStockpercentage !== undefined &&
                                            order?.orderType === "WHOLESALE" && (
                                              <span style={{ display: "flex", justifyContent: "flex-start", fontSize: "12px", margin: 0, padding: 0 }}>
                                                Advance Amt : {order?.payment?.actualOrderStockpercentage} %
                                              </span>
                                            )}
                                          <span style={{ display: "flex", justifyContent: "flex-start", fontSize: "12px", margin: 0, padding: 0 }}>Pending Amt : ₹ {Math.round(order?.payment?.amountNeedToBePaid || 0)}</span>
                                        </div>)}
                                      </div>

                                    </div>
                                  </div>
                                )}


                                {activeTab !== "NON RETURNABLE" &&
                                  <div
                                    key={order.id}
                                    className="order-navigate"
                                    onClick={() => handleRowClick(order)}
                                  >
                                    <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                                      {order?.items?.some(item => item?.partOfBundle === true) && (
                                        <div className="badge-sample-dark-bundle">BUNDLE</div>
                                      )}
                                      {order?.items?.some(item => item?.combo === true) && (
                                        <div className="badge-sample-dark-combo">COMBO</div>
                                      )}
                                      {order?.orderType ? order?.items?.some(item => item?.combo !== true) && (<div className="badge-sample-dark" style={{ fontSize: "10px", width: "fit-content" }}>
                                        {order?.orderType}
                                      </div>) : ""}
                                    </div>
                                    <div className="row">
                                      <div >

                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                          <div >


                                          </div>
                                          <div className="product-info">
                                            {order?.orderType === "SWATCH" ? (

                                              <span className="row-product-name" >
                                                {order?.items?.[0]?.productName}
                                              </span>) : (
                                              <span className="row-product-name" >
                                                {order?.orderType === "WHOLESALE" || order?.orderType === "COMBO" || order?.orderStatus === "RETURNED"
                                                  ? [...new Set(order?.items?.map(item => item?.productName).filter(Boolean))].join(' | ')
                                                  : order?.productVariant?.name?.split('/')[0] || order?.productName}
                                              </span>)}
                                            <div className="product-details">
                                              <span className="detail" >
                                                {order.orderType !== "SWATCH" ? (
                                                  <>
                                                    {order?.items?.some(item => item?.partOfBundle === true) && (<div className="iYY1OFF">
                                                      <span className="E303nnp">
                                                        <div
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          RIB : <span style={{ color: "black", fontWeight: "bold", letterSpacing: "0.1px" }}>{[
                                                            ...new Set(
                                                              order?.items
                                                                ?.filter(item => item?.ribItem)
                                                                ?.map(item => item?.ribItem?.productName)
                                                            ),
                                                          ].join(", ")}</span>
                                                        </div>
                                                      </span>
                                                    </div>)}

                                                    <span>{renderColorCode(order?.items)}</span>

                                                    <div >
                                                      <span>
                                                        <div
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          UOM :  {order?.items?.[0]?.uom}
                                                        </div>
                                                      </span>
                                                    </div>
                                                    {order.orderType === 'WHOLESALE' && <div className="iYY1OFF">
                                                      <span className="E303nnp">
                                                        <div
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                          className="mKEOO+e"
                                                        >
                                                          No of Rolls :{" "}
                                                          {
                                                            order?.items?.reduce((sum, item) => {
                                                              const mainRolls = item?.orderedRolls || 0;
                                                              const ribRolls = item?.ribItem?.orderedRolls || 0;
                                                              return sum + mainRolls + ribRolls;
                                                            }, 0)
                                                          }


                                                        </div>
                                                      </span>
                                                      {activeTab === "PART PROCESSED" && order?.approvedRolls > 0 && <span className="E303nnp">
                                                        <div
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                          className="mKEOO+e"
                                                        >
                                                          Approved Rolls :{" "}
                                                          {order?.approvedRolls}
                                                        </div>
                                                      </span>}
                                                    </div>}

                                                    <div className="iYY1OtyF">
                                                      <div className="E303tnynp">
                                                        <div
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                          className="mKEytOO+e"
                                                        >
                                                          Total Qty :{" "}
                                                          {
                                                            order?.items?.reduce(
                                                              (sum, item) => sum + (item?.qty || 0),
                                                              0
                                                            )
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <>


                                                    <div className="iYY1OFF">
                                                      <span className="E303nnp">
                                                        <div
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                          className="mKEOO+e"
                                                        >
                                                          UOM: {order?.uom}
                                                        </div>
                                                      </span>
                                                    </div>
                                                    <div className="iYY1OtyF">
                                                      <div className="E303tnynp">
                                                        <div
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                          className="mKEytOO+e"
                                                        >
                                                          Total Qty :{" "}
                                                          {order?.qty
                                                            ? order.qty
                                                            : "N/A"}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </>
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>



                                      <div className="col-4-13-delivery-info">
                                        <div>
                                          <div className="status-icon" />
                                          {activeTab !== "PART PROCESSED" && <span className="delivery-date">
                                            {order.orderStatus}
                                          </span>}

                                          {activeTab === "PART PROCESSED" && <span className="delivery-date">
                                            {order?.allowAllocation === true ? "CONFIRMED" : "NOT CONFIRMED"}
                                          </span>}
                                          <div className="delivery-status">
                                            {getDeliveryStatusMessage(
                                              order.orderStatus
                                            )}
                                            {activeTab === "PART PROCESSED" && <p style={{ color: 'red' }}>{order?.fullyAllocated === true ? "processed" : "Allocation Pending"}</p>}
                                          </div>
                                          <div className="delivery-status">{order?.purchaseMode === 'SO' && <div style={{ display: 'flex', flexDirection: "row", fontSize: "12px" }} >
                                            <span style={{ display: "flex", color: "gray", marginRight: "5px" }}>NOTE : </span> <span style={{ display: "flex", color: "gray" }}> Refund Not Allowed For This Order</span><span style={{ display: "flex", paddingLeft: "3px", alignItems: "center", color: "gray" }}><FontAwesomeIcon icon={faBan} /> </span>

                                          </div>}</div>
                                        </div>
                                        <div className="space"></div>
                                      </div>
                                      <div style={{ display: "flex", padding: "5px", fontWeight: "bold" }}>
                                        {!isMobile && activeTab !== "PART PROCESSED" && activeTab !== "DC ORDER" && order?.orderStatus !== "CANCELLED" && (<div style={{ display: "flex", flexDirection: "column" }}>

                                          <span style={{ display: "flex", justifyContent: "flex-start", fontSize: "12px", margin: 0, padding: 0 }}>Order Amt  : ₹ {Math.round((order?.payment?.totalAmount || 0) - (order?.payment?.paidAmount || 0))}</span>
                                          <span style={{ display: "flex", justifyContent: "flex-start", fontSize: "12px", margin: 0, padding: 0 }}>Paid Amt : ₹ {Math.round(order?.payment?.paidAmount || 0)}</span>
                                          {order?.payment?.actualOrderStockpercentage !== null &&
                                            order?.payment?.actualOrderStockpercentage !== undefined &&
                                            order?.orderType === "WHOLESALE" && (
                                              <span style={{ display: "flex", justifyContent: "flex-start", fontSize: "12px", margin: 0, padding: 0 }}>
                                                Advance Amt : {order?.payment?.actualOrderStockpercentage} %
                                              </span>
                                            )}
                                          <span style={{ display: "flex", justifyContent: "flex-start", fontSize: "12px", margin: 0, padding: 0 }}>Pending Amt : ₹ {Math.round(order?.payment?.amountNeedToBePaid || 0)}</span>
                                        </div>)}
                                      </div>
                                    </div>
                                  </div>}


                              </div>

                            </React.Fragment>
                          );
                        })}
                      </div>
                    ))}
                  </div>


                ) : (
                  !loading && (
                    <div style={{ marginTop: "1rem" }}>
                      No orders found for <span style={{ fontWeight: "bold", color: "#8BC53F" }}>{activeTab}</span> status.
                    </div>
                  )
                )}
              </InfiniteScroll>
            </Tabs.Panel>
          </Tabs>

        </div>

      </div >

      {cancelOpened && (<Modal
        opened={cancelOpened}
        onClose={() => setCancelOpened(false)}
        title="Order Cancel Status"
        centered
        overlayProps={{
          backgroundOpacity: 0.55,
          blur: 3
        }}
        classNames={{
          content: "custom-modal-content",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {selectedOrder && (
          <>
            <p>
              Are you sure? Do you want to cancel
              <span style={{ fontWeight: "bold" }}> {selectedOrder.orderNo} </span>?
            </p>
            <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "1rem" }}>
              <Button color="red" onClick={() => setCancelOpened(false)}>No</Button>
              <Button
                color="#8BC54F"
                onClick={() => {
                  cancelProduct(selectedOrder);
                  setCancelOpened(false);
                }}
              >
                {isCancelling === selectedOrder?.orderNo ? (
                  <Loader size="sm" color="#fff" />
                ) : (
                  "Yes"
                )}
              </Button>
            </div>
          </>
        )}
      </Modal>)}

      <Modal
        opened={paymentOpened}
        onClose={paymentClose}
        title="Payment Details"
        centered
        overlayProps={{
          backgroundOpacity: 0.55,
          blur: 3
        }}
        classNames={{
          content: "custom-modal-content",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <PayNow
          payment={salesOrder?.payment}
          acceptPayment1={() => AcceptPaymentt(salesOrder?.payment?.id)}
          approveAdvance={approveAdvance}
          paymentClose={paymentClose}
          setSaveTransaction={setSaveTransaction}
          saveTransaction={saveTransaction}
          salesOrder={salesOrder}
          setSalesOrder={setSalesOrder}
          acceptPayment={(v) => {
            acceptPayment({
              orderNo: v?.payment?.referenceNo,
              receiptNo: v?.payment?.adjustmentType === "DC" ? v?.payment?.referenceNo : null
            })
            paymentClose()
          }}
          customerId={salesOrder?.customerId}
        />
      </Modal>
    </>

  );
};

export default PlaceOrdersDetails;




